import { ServiceBase } from '../../../../core/services/ServiceBase'
import CartProxy from '../proxies/CartProxy'

class CartService extends ServiceBase {
  getCartQuantity() {
    return this.getData(() => CartProxy.getCartQuantity())
  }
}

export default new CartService()
